let _infowindow = null;
let _canvas = null;
let _drawingManager = null;
let _selectedShape = null;
let _newShapes = [];
let _siblingShapes = [];
let _hasAutocomplete = false;
let _hasAutocompleteGetPlaceCallback = false;
let _isFirstHit = false;
let _isDrawActive = false;
let _isReadOnly = false;
let _controls = [];
const _deleteAllClassName = 'delete-all drawing-mgr--control';
const _deleteClassName = 'delete drawing-mgr--control';
const _drawClassName = 'draw drawing-mgr--control';
const _applyClassName = 'save drawing-mgr--control';

function _isEmpty(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function _onPlaceChangedAutoComplete(autocomplete) {
  const place = autocomplete.getPlace();
  if (!place.geometry) {
    // User entered the name of a Place that was not suggested and
    // pressed the Enter key, or the Place Details request failed.
    window.alert("No details available for input: '" + place.name + "'");
    return;
  }

  // If the place has a geometry, then present it on a map.
  if (place.geometry.viewport) {
    _canvas.fitBounds(place.geometry.viewport);
  } else {
    _canvas.setCenter(place.geometry.location);
  }

  _canvas.setZoom(15);
  return place;
}

function _clearShapeSelection() {
  if (_selectedShape) {
    _selectedShape.setEditable(false);
    _selectedShape = null;
  }
}

function _setShapeSelection(shape) {
  _infowindow.close();
  _clearShapeSelection();
  _selectedShape = shape;
  shape.setEditable(true);
}

function _deleteShapeSelection() {
  if (_selectedShape) {
    for (let index = 0; index < _newShapes.length; index++) {
      const shape = _newShapes[index];
      if (shape.maverickId === _selectedShape.maverickId) {
        _newShapes.splice(index, 1);
        break;
      }
    }
    _selectedShape.setMap(null);
  }
}

function _deleteAllShape() {
  for (let index = 0; index < _newShapes.length; index++) {
    _newShapes[index].setMap(null);
    _newShapes.splice(index, 1);
    index--;
  }
}

function _deleteAllSiblingShape() {
  for (let index = 0; index < _siblingShapes.length; index++) {
    _siblingShapes[index].setMap(null);
    _siblingShapes.splice(index, 1);
    index--;
  }
}

function _generateId() {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return Math.random().toString(36).substr(2, 9);
}

function _addControl(attribute) {
  const button = document.createElement("div");
  button.className = attribute.className;
  button.title = attribute.title;
  button.innerHTML = attribute.innerHTML;
  button.addEventListener("click", (e) => attribute.callback(e));
  _controls.push(button);
}

class MaverickDrawingManager {
  constructor(config) {
    if (_isEmpty(config)) {
      return;
    }

    _controls = [];
    _isDrawActive = false;

    // mapId: string
    // lat: double
    // lng: double
    // readOnly: bool
    // autocomplete: bool
    // autocompleteGetPlaceCallback: function
    // saveCallback: function
    // deleteCallback: function
    // deleteAllCallback: function
    this.config = config;

    _isReadOnly = config.readOnly && config.readOnly === true;
    _hasAutocomplete = config.autocomplete && config.autocomplete === true;
    _hasAutocompleteGetPlaceCallback = config.autocompleteGetPlaceCallback;

    _infowindow = new google.maps.InfoWindow();

    _canvas = new google.maps.Map(
      document.getElementById(this.config.mapId), {
        center: {
          lat: this.config.lat,
          lng: this.config.lng
        },
        zoom: 15,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true
      }
    );

    _canvas.setOptions({
      styles: [{
          featureType: "poi.business",
          stylers: [{
            visibility: "off"
          }],
        },
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [{
            visibility: "off"
          }]
        },
        {
          featureType: "transit",
          elementType: "labels.icon",
          stylers: [{
            visibility: "off"
          }],
        },
      ]
    });

    _canvas.addListener("bounds_changed", () => {
      const container = document.getElementsByClassName("pac-container")[0];
      if (container !== undefined && container !== null) {
        container.setAttribute("style", "z-index: 2000;");
      }
    });

    _canvas.addListener('click', _clearShapeSelection);

    // Autocomplete
    if (_hasAutocomplete) {
      _canvas.controls[google.maps.ControlPosition.TOP_CENTER].push(
        document.getElementById("pac-card")
      );

      const autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("pac-input")
      );

      // Bind the map's bounds (viewport) property to the autocomplete object,
      // so that the autocomplete requests use the current map bounds for the
      // bounds option in the request.
      autocomplete.bindTo("bounds", _canvas);

      // Set the data fields to return when the user selects a place.
      autocomplete.setFields(["address_components", "formatted_address", "geometry", "name", "place_id"]);

      // attach event listener
      autocomplete.addListener("place_changed", (_) => {
        const place = _onPlaceChangedAutoComplete(autocomplete);
        if (_hasAutocompleteGetPlaceCallback) {
          this.config.autocompleteGetPlaceCallback(place);
        }
      });
    }

    if (!_isReadOnly) {
      // DrawingManager
      _drawingManager = new google.maps.drawing.DrawingManager({
        drawingControl: false, // hide default control from canvas
        polygonOptions: {
          clickable: true,
          editable: true,
          draggable: true,
        }
      });

      _drawingManager.setMap(_canvas);

      _drawingManager.addListener('overlaycomplete', (event) => {
        if (event.type !== google.maps.drawing.OverlayType.MARKER) {
          // Switch back to non-drawing mode after drawing a shape.
          _drawingManager.setDrawingMode(null);

          _isDrawActive = false;
          _controls.find(x => x.className.includes(_drawClassName)).innerHTML = 'Draw';

          const newShape = event.overlay;
          newShape.type = event.type;
          newShape.maverickId = _generateId();

          _newShapes.push(newShape);

          if (!_isReadOnly) {
            _setShapeSelection(newShape);

            // Add an event listener that selects the newly-drawn shape when the user mouses down on it.
            newShape.addListener('click', () => _setShapeSelection(newShape));
          }
        }
      });

      _drawingManager.addListener('drawingmode_changed', _clearShapeSelection);

      const wrapperControls = document.createElement("div");

      // custom control: delete all
      _addControl({
        className: `btn btn-default ${_deleteAllClassName}`,
        title: "Remove all new polygon from canvas",
        innerHTML: "Reset",
        callback: (_) => {
          _deleteAllShape();
          this.config.deleteAllCallback();
        }
      });

      // custom control: delete
      _addControl({
        className: `btn btn-default ${_deleteClassName}`,
        title: "Remove selected polygon from canvas",
        innerHTML: "Delete",
        callback: (_) => {
          _deleteShapeSelection();
          this.config.deleteCallback();
        }
      });

      // custom control: draw
      _addControl({
        className: `btn btn-default ${_drawClassName}`,
        title: "Draw a new polygon on canvas",
        innerHTML: "Draw",
        callback: (e) => {
          if (_isDrawActive) {
            _drawingManager.setDrawingMode(null);
            e.target.innerHTML = 'Draw';
          } else {
            _drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
            e.target.innerHTML = "Stop Draw";
          }
          _isDrawActive = !_isDrawActive;
        }
      });

      // custom control: apply
      _addControl({
        className: `btn btn-primary ${_applyClassName}`,
        title: "Apply all changes",
        innerHTML: "Apply",
        callback: (_) => {
          if (_newShapes.length === 0) {
            alert('Shape is not exist.');
            return;
          }

          if (_newShapes.length > 1) {
            alert('Multiple shape exist.');
            return;
          }

          const coordinates = [];
          const vertices = _newShapes[0].getPath();
          for (let index = 0; index < vertices.getLength(); index++) {
            const latLng = vertices.getAt(index);
            coordinates.push({
              latitude: latLng.lat(),
              longitude: latLng.lng()
            });
          }

          // make sure all line are connected
          const firstPoint = coordinates[0];
          const lastPoint = coordinates[coordinates.length - 1];
          if (firstPoint.latitude !== lastPoint.latitude && firstPoint.longitude !== lastPoint.longitude) {
            coordinates.push({
              latitude: firstPoint.latitude,
              longitude: firstPoint.longitude
            });
          }

          this.config.saveCallback(coordinates);
        }
      });

      for (let index = 0; index < _controls.length; index++) {
        wrapperControls.appendChild(_controls[index]);
      }

      _canvas.controls[google.maps.ControlPosition.BOTTOM_CENTER].push(wrapperControls);

      google.maps.event.addListener(_canvas, "rightclick", () => {
        _isDrawActive = false;
        _drawingManager.setDrawingMode(null);
        _controls.find(x => x.className.includes(_drawClassName)).innerHTML = 'Draw';
      });

      // Change the escape key behavior.
      window.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        _isDrawActive = false;
        _drawingManager.setDrawingMode(null);
        _controls.find(x => x.className.includes(_drawClassName)).innerHTML = 'Draw';
      });
    }

    google.maps.event.addListener(_canvas, 'idle', () => {
      if (_isFirstHit) {
        _isFirstHit = false;
        if (_selectedShape) {
          const bounds = new google.maps.LatLngBounds();
          _selectedShape.getPath().forEach(function (path) {
            bounds.extend(path);
          });
          _canvas.fitBounds(bounds);
        }
      }
    });
  }

  load(main, siblings) {
    this.reset();
    _isFirstHit = true;

    if (!_isReadOnly) {
      // Switch back to non-drawing mode after drawing a shape.
      _drawingManager.setDrawingMode(null);
    }

    if (main && main.length > 0) {
      const mainShape = new google.maps.Polygon({
        map: _canvas,
        paths: main.map((x) => {
          return {
            lat: x.latitude,
            lng: x.longitude
          };
        }),
        clickable: !_isReadOnly,
        editable: !_isReadOnly,
        draggable: !_isReadOnly,
      });
      mainShape.maverickId = _generateId();

      _newShapes.push(mainShape);
      _setShapeSelection(mainShape);

      // Add an event listener that selects the newly-drawn shape when the user mouses down on it.
      mainShape.addListener('click', () => _setShapeSelection(mainShape));
    }

    // #FF0000 red
    // #1E90FF blue
    // #FF1493 pink
    // #32CD32 green
    // #FF8C00 orange
    // #4B0082 purple
    if (siblings && siblings.length > 0) {
      for (let i = 0; i < siblings.length; i++) {
        const sibling = new google.maps.Polygon({
          map: _canvas,
          paths: siblings[i].points.map((x) => {
            return {
              lat: x.latitude,
              lng: x.longitude
            };
          }),
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
          geodesic: false,
        });

        // Add an event listener that selects the newly-drawn shape when the user mouses down on it.
        sibling.addListener('click', (e) => {
          _infowindow.setContent(siblings[i].name);
          _infowindow.setPosition(e.latLng);
          _infowindow.open(_canvas);
        });

        _siblingShapes.push(sibling);
      }
    }
  }

  reset() {
    _infowindow.close();
    _deleteAllShape();
    _deleteAllSiblingShape();
    _newShapes = [];
    _siblingShapes = [];
  }
}

export default MaverickDrawingManager;



// WEBPACK FOOTER //
// ./src/plugins/google/drawingManager.js